import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678be1e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "form-wrapper",
  id: "form-wrapper"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "info-text"
}
const _hoisted_4 = {
  key: 1,
  class: "info-text"
}
const _hoisted_5 = {
  key: 2,
  class: "info-text"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = {
  disabled: "",
  selected: "",
  value: 0
}
const _hoisted_8 = {
  key: 0,
  value: 1,
  style: {"font-weight":"bold"}
}
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-group__row" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "v-message" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "v-message" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "v-message" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "v-message" }
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "label" }
const _hoisted_25 = { class: "v-message" }
const _hoisted_26 = { class: "form-group__row" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "label" }
const _hoisted_29 = { class: "v-message" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = { class: "label" }
const _hoisted_32 = { class: "v-message" }
const _hoisted_33 = {
  key: 0,
  class: "mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, {
      onSubmit: _ctx.onSubmit,
      ref: "form"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.selectedCustomer.externalId)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('Checkout.AddNewCustomer')), 1))
            : (!_ctx.isCheckoutPage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('Checkout.EditCompanyCustomer')), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('Checkout.DeliveryToFollowingCustomer')), 1)),
          _withDirectives(_createElementVNode("select", {
            id: "customerSelect",
            class: "input form-control select-container",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setCustomer(_ctx.selectedValue))),
            "aria-label": _ctx.$t('Checkout.SelectCustomer')
          }, [
            _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("Checkout.SelectCustomer")), 1),
            (_ctx.selectedCustomer.externalId)
              ? (_openBlock(), _createElementBlock("option", _hoisted_8, _toDisplayString(_ctx.$t("Checkout.SetNewCustomer")), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyCustomers, (customer) => {
              return (_openBlock(), _createElementBlock("option", {
                key: customer.externalId,
                value: customer.externalId
              }, _toDisplayString(customer.firstName + " " + customer.lastName) + " (" + _toDisplayString(customer.deliveryAddresses[0].city) + ") ", 9, _hoisted_9))
            }), 128))
          ], 40, _hoisted_6), [
            [_vModelSelect, _ctx.selectedValue]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("Common.FirstName")), 1),
            _createVNode(_component_v_field, {
              id: "name",
              disabled: _ctx.disableFields,
              name: "name",
              type: "text",
              modelValue: _ctx.selectedCustomer.firstName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCustomer.firstName) = $event)),
              class: "input form-control",
              rules: "required",
              label: _ctx.$t('Common.FirstName'),
              placeholder: _ctx.$t("ContactForm.FirstNamePlaceholder")
            }, null, 8, ["disabled", "modelValue", "label", "placeholder"]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_v_message, { name: "name" })
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("Common.LastName")), 1),
            _createVNode(_component_v_field, {
              disabled: _ctx.disableFields,
              name: "lastName",
              type: "text",
              modelValue: _ctx.selectedCustomer.lastName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedCustomer.lastName) = $event)),
              class: "input form-control",
              rules: "required",
              label: _ctx.$t('Common.LastName'),
              placeholder: _ctx.$t("ContactForm.LastNamePlaceholder")
            }, null, 8, ["disabled", "modelValue", "label", "placeholder"]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_v_message, { name: "lastName" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("Common.MobilePhone")), 1),
          _createVNode(_component_v_field, {
            disabled: _ctx.disableFields,
            name: "mobilePhone",
            modelValue: _ctx.selectedCustomer.mobilePhone,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCustomer.mobilePhone) = $event)),
            type: "number",
            class: "input form-control",
            rules: _ctx.validatePhone,
            label: _ctx.$t('Common.MobilePhone'),
            placeholder: _ctx.$t("ContactForm.PhoneNumberPlaceholder")
          }, null, 8, ["disabled", "modelValue", "rules", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_message, { name: "mobilePhone" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Registererror.PhoneNotValid')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
          _createVNode(_component_v_field, {
            disabled: _ctx.disableFields,
            name: "email",
            type: "email",
            modelValue: _ctx.selectedCustomer.email,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCustomer.email) = $event)),
            class: "input form-control",
            rules: "required|email",
            label: _ctx.$t('Common.EmailAddress'),
            placeholder: _ctx.$t("ContactForm.EmailPlaceholder")
          }, null, 8, ["disabled", "modelValue", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_v_message, { name: "email" })
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("Common.Address1")), 1),
          _createVNode(_component_v_field, {
            disabled: _ctx.disableFields,
            name: "line1",
            type: "text",
            modelValue: _ctx.selectedCustomer.line1,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCustomer.line1) = $event)),
            class: "input form-control",
            rules: _ctx.validateAddress,
            label: _ctx.$t('Common.Address1'),
            placeholder: _ctx.$t("ContactForm.AddressPlaceholder")
          }, null, 8, ["disabled", "modelValue", "rules", "label", "placeholder"]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_v_message, { name: "line1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Registererror.Line1NotValid')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("Common.ZipCode")), 1),
            _createVNode(_component_v_field, {
              disabled: _ctx.disableFields,
              name: "zip",
              type: "text",
              modelValue: _ctx.selectedCustomer.zip,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCustomer.zip) = $event)),
              class: "input form-control",
              rules: _ctx.validateZip,
              label: _ctx.$t('Common.ZipCode'),
              placeholder: _ctx.$t("ContactForm.ZipCodePlaceholder")
            }, null, 8, ["disabled", "modelValue", "rules", "label", "placeholder"]),
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_v_message, { name: "zip" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Registererror.ZipNotValid')), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("Common.City")), 1),
            _createVNode(_component_v_field, {
              disabled: _ctx.disableFields,
              name: "city",
              type: "text",
              modelValue: _ctx.selectedCustomer.city,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedCustomer.city) = $event)),
              class: "input form-control",
              rules: _ctx.validateAddress,
              label: _ctx.$t('Common.City'),
              placeholder: _ctx.$t("ContactForm.CityPlaceholder")
            }, null, 8, ["disabled", "modelValue", "rules", "label", "placeholder"]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_v_message, { name: "city" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Registererror.CityNotValid')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        (!_ctx.selectedCustomer.externalId)
          ? (_openBlock(), _createBlock(_component_BaseButton, {
              key: 0,
              class: "button--base button--primary",
              type: "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Common.Save')), 1)
              ]),
              _: 1
            }))
          : (!_ctx.isCheckoutPage)
            ? (_openBlock(), _createBlock(_component_BaseButton, {
                key: 1,
                class: "button--base button--primary",
                type: "submit"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Common.Update')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    (_ctx.displayResponseMsg)
      ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.responseMessage), 1))
      : _createCommentVNode("", true)
  ]))
}